export const GET_FACILITY_UNIT_SUCCESS = 'GET_FACILITY_UNIT_SUCCESS'
export const GET_FACILITY_UNIT_REQUEST = 'GET_FACILITY_UNIT_REQUEST'
export const GET_FACILITY_UNIT_FAILURE = 'GET_FACILITY_UNIT_FAILURE'
